
import {Prop} from 'vue-property-decorator'
import Vue from 'vue'
import Component from 'vue-class-component'
import CardTitle from '@/components/Atomic/CardTitle.vue'
import BlueButton from '@/components/Atomic/BlueButton.vue'
import RedButton from '@/components/Atomic/RedButton.vue'
import GreenButton from '@/components/Atomic/GreenButton.vue'
import { OrganisationJobTitle } from '@/models/organisationJobTitle'
import ErrorHandlerService from '@/services/ErrorHandlerService'
import INotificationService from '@/services/NotificationService'
import OrganisationsService from '@/services/OrganisationsService'
import ProgressLinear from '@/components/Atomic/ProgressLinear.vue'

@Component({
  components: {
    CardTitle,
    BlueButton,
    RedButton,
    GreenButton,
    ProgressLinear,
  },
})

export default class UpdateJobTitles extends Vue {
  @Prop() public readonly jobTitle!: OrganisationJobTitle
  @Prop(Function) public readonly onDialogClose!: () => void

  private errorHandlerService: ErrorHandlerService
  private $notificationService!: INotificationService

  private jobTitleDialog: boolean = false
  private isPending: boolean = false

  constructor() {
    super()
    this.errorHandlerService = new ErrorHandlerService()
  }

  private show() {
    this.$validator.reset()
  }

  private mounted() {

  }

  private resetDialog() {
    this.jobTitleDialog = false
  }

  private async update() {
    this.isPending = true
    try {
      const id = this.jobTitle.id
      const title = this.jobTitle.title
      const isValidated = this.jobTitle.is_validated
      const forGuest = this.jobTitle.for_guest
      await OrganisationsService.updateJobTitle(id, title, forGuest, isValidated)
      this.$notificationService.success(this.$t('EXTRAS.JobTitleUpdated').toString())
    } catch (error: any) {
      this.errorHandlerService.handle(this, error.response.data.code, true)
    }
    this.isPending = false
    this.jobTitleDialog = false
  }
}
